import { Button, Col, Form, Row, Table } from "react-bootstrap";
import { HeaderRegister } from "../../components/HeaderRegister";
import { BranchService } from "../../services/branch.service";
import { useEffect, useRef, useState } from "react";
import { ToastService } from "../../services/toast.service";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { FieldArray, Formik } from "formik";
import * as yup from "yup";
import { BranchModel } from "../../models/branch.model";
import { TransporterModel } from "../../models/transporter.model";
import TransporterService from "../../services/transporter.service";
import BranchMonitoringService from "../../services/branchMonitoring.service";
import _ from "lodash";
import DatePicker from "react-datepicker";
import storageService from "../../services/storage.service";
import moment from "moment";
import { MonitoringSystemModel } from "../../models/monitoringSystem.model";
import MonitoringSystemService from "../../services/monitoringSystem.service";
import { DatasetModel } from "../../models/dataset.model";
import { DatasetDefault } from "../../models/dataset.model";
import {
  RequestInputOutputParamsModel,
  RequestInputOutputParamsModelDefault,
} from "../../models/requestInputOutputParams.model";

import { InputTags } from "react-bootstrap-tagsinput";
//import "react-bootstrap-tagsinput/dist/index.css";

import EmailChip from "../../components/EmailChip/EmailChip";
import UserService from "../../services/user.service";
import { AddressStateModel } from "../../models/addressState.model";
import LocaleService from "../../services/locale.service";
import Select from 'react-select';

export const BranchRegister = () => {
  const { id } = useParams<{ id?: string }>();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [initialValues, setInitialValues] = useState<BranchModel>({
    id: null,
    fullName: "",
    nickName: "",
    document: "",
    transporterId: undefined,
    worksOnMonday: "0",
    worksOnTuesday: "0",
    worksOnWednesday: "0",
    worksOnThursday: "0",
    worksOnFriday: "0",
    worksOnSunday: "0",
    worksOnSaturday: "0",

    extraHourOnMonday: "0",
    extraHourOnTuesday: "0",
    extraHourOnWednesday: "0",
    extraHourOnThursday: "0",
    extraHourOnFriday: "0",
    extraHourOnSunday: "0",
    extraHourOnSaturday: "0",

    exceedOnMonday: "0",
    exceedOnTuesday: "0",
    exceedOnWednesday: "0",
    exceedOnThursday: "0",
    exceedOnFriday: "0",
    exceedOnSunday: "0",
    exceedOnSaturday: "0",

    regionalCodeRef: 0,
    branchCodeRef: 0,

    branchMonitoringList: [],
    startTime: "",
    finishTime: "",
    intervalTime: "",
    monitoringSystemId: 0,
    addressStateId: undefined,
    branchEquipBelowMinForApproval : undefined,
  });
  const formRef = useRef();
  const history = useHistory();
  const [transporters, setTransporters] = useState<TransporterModel[]>();
  const [groupBranchData, setGroupBranchData] = useState([]);
  const [monitoringSystemList, setMonitoringSystemList] =
    useState<MonitoringSystemModel[]>();

  const [states, setStates] = useState<AddressStateModel[]>();    
  const user = storageService.getUser();
  const [emails, setEmails] = useState<any>({});
  //sprint 27  - 10238 - Relat�rio Indicador - Coleta imposta sem programa��o da Filial - Fase 1
  //const [emails_branch_manager, setEmails_branch_manager] = useState<any>({});
  //sprint 27  - 10238 - Relat�rio Indicador - Coleta imposta sem programa��o da Filial - Fase 1
  const initialize = async () => {
    

    await LocaleService.getAllStatesbyLocale().then(async (response: any) => {
      if (response.success) {
        let statesList = response.result.datasets.filter((dataset) => { return dataset.dataset === 'states' });
        setStates(statesList[0].data);
      } else {
        setStates([]);
      }
    });

    if (Number(id)) {
      let result: any = {};
      const response: any = await BranchService.getById(id);
      if (response.success) {
        result = response.result;
        const responseBranchMonitoring: any =
          await BranchMonitoringService.getByBranchId(id);
        if (responseBranchMonitoring.success) {
          result.branchMonitoringList = responseBranchMonitoring.result;
        }

        if (result.emailBranch && result.emailBranch?.length > 0) {
          setEmails({
            items: result.emailBranch.split(";"),
            value: "",
            error: null
          });
        }
        //sprint 27  - 10238 - Relat�rio Indicador - Coleta imposta sem programa��o da Filial - Fase 1
        if (result.emailBranchManager && result.emailBranchManager?.length > 0) {
          /* setEmails_branch_manager({
            items: result.emailBranchManager.split(";"),
            value: "",
            error: null
          }); */
        }
        //sprint 27  - 10238 - Relat�rio Indicador - Coleta imposta sem programa��o da Filial - Fase 1
        setInitialValues(result);
      }
    }

    TransporterService.getAll().then((response: any) => {
      if (response.success === true && response.result) {
        let d: DatasetModel = _.last(
          _.filter(response.result.datasets, { dataset: "transporter" })
        );

      const sort = (d?.data ?? []).sort((a, b) =>
        a.fullName.localeCompare(b.fullName)
      );

        setTransporters(sort);
      }
    });

    MonitoringSystemService.getAll().then((response: any) => {
      setMonitoringSystemList(response.result);
    });

    const responseGroupBranch: any = await UserService.GetGroupBranchByUserApprove(id);
    console.log("responseGroupBranch", responseGroupBranch.result.datasets)
    if (responseGroupBranch && responseGroupBranch.result) {
      // Verificar se datasets é um array e se contém a propriedade data
      if (Array.isArray(responseGroupBranch.result.datasets)) {
        const datasets = responseGroupBranch.result.datasets;
        // Assume que datasets pode ter uma propriedade data
        const data = datasets.length > 0 ? datasets[0].data : [];
        setGroupBranchData(data);
      } else {
        console.error("Unexpected datasets structure:", responseGroupBranch.result.datasets);
      }
    } else {
      console.error("Unexpected response structure:", responseGroupBranch);
    }
  };


  useEffect(() => {
    initialize();
  }, []);

  const schema = yup.object().shape({
    fullName: yup.string().required(t("REQUIRED")),
    nickName: yup.string().required(t("REQUIRED")),
    document: yup.string().required(t("REQUIRED")),
    transporterId: yup.string().required(t("REQUIRED")),
    addressStateId: yup.string().required(t("REQUIRED")),
    regionalCodeRef: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? 0 : Number(originalValue)))
    .min(0, t("REQUIRED"))
    .required(t("REQUIRED")),
  
  branchCodeRef: yup
    .number()
    .transform((value, originalValue) => (originalValue === "" ? 0 : Number(originalValue)))
    .min(0, t("REQUIRED"))
    .required(t("REQUIRED")),
  });

  const submitFormik = () => {
    if (formRef && formRef.current) {
      let current: any = formRef.current;
      current.handleSubmit();
    }
  };

  const saveBranch = (branch: BranchModel) => {
    if (emails && emails?.items?.length > 0) {
      branch["emailBranch"] = emails.items.join(";");
    }
    else {
      branch["emailBranch"] = null;
    }
    //sprint 27  - 10238 - Relat�rio Indicador - Coleta imposta sem programa��o da Filial - Fase 1
    /* if (emails_branch_manager && emails_branch_manager?.items?.length > 0) {
      branch["emailBranchManager"] = emails_branch_manager.items.join(";");
    }
    else {
      branch["emailBranchManager"] = null;
    } */
    //sprint 27  - 10238 - Relat�rio Indicador - Coleta imposta sem programa��o da Filial - Fase 1
    const payload = {
      ...JSON.parse(JSON.stringify(DatasetDefault)),
      dataset: "branch",
      data: [branch],
    };

    let reqData: RequestInputOutputParamsModel = {
      ...RequestInputOutputParamsModelDefault,
      datasets: [payload],
    };

    setLoading(true);
    if (branch.id > 0) {
      BranchService.update(reqData)
        .then((response: any) => {
          if (
            response.result.message_type != null &&
            response.result.message_type == "WARNING"
          ) {
            ToastService.success(t("BRANCH.UPDATED"));
            ToastService.warn(t(response.result.message_code), null);
            history.push(`/Branch`);
          } else {
            ToastService.success(t("BRANCH.UPDATED"));
            history.push(`/Branch`);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      BranchService.insert(reqData)
        .then((response: any) => {
          if (response.success) {
            ToastService.success(t("BRANCH.INSERTED"));
            history.push("/Branch");
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const ListYesNo = [
      { value: 1, label: t("YES") },
      { value: 0, label: t("NO")  }
  ];
  // const handleNickName = (evt: any) => {
  //   if(evt.target.value.toString().length <= 6){
  //     setInitialValues({
  //       ...initialValues,
  //       nickName: evt.target.value.toString()
  //     });
  //   }
  // };

  return (
    <>
      <HeaderRegister
        title={`${t("BRANCH.TITLE")} | ${window.location.hash.includes("add")
          ? t("REGISTRATION")
          : t("EDITION")
          }`}
        path={"/Branch"}
        submitForm={submitFormik}
        isLoading={isLoading || user.profile.profileName === "adm_reader" || user.profile.profileName === "sys_admin"}
      />

      <Formik
        enableReinitialize={true}
        innerRef={formRef}
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={(values, actions) => {
          let valuesToSave = _.clone(values);

          // Garantir que regionalCodeRef e branchCodeRef nunca sejam null
          valuesToSave.regionalCodeRef = valuesToSave.regionalCodeRef ?? 0;
          valuesToSave.branchCodeRef = valuesToSave.branchCodeRef ?? 0;

          //valuesToSave.branchMonitoringList = _.map(valuesToSave.branchMonitoringList, (value) => { return { ...value, branchId: valuesToSave.id } });
          saveBranch(valuesToSave);
        }}>
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          touched,
          isValid,
          errors,
          setValues,
          setFieldValue,
        }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Row>
              {/* {JSON.stringify(values)}
              {JSON.stringify(errors)} */}
              <Col xs={12} xl={12}>
                <Row className='align-items-center'>
                  <Col sm={12} md={6} lg={3} className='mb-4'>
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='fullName'
                          id='fullName'
                          type='text'
                          placeholder={t("BRANCH.FULLNAME")}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.fullName && !!errors.fullName}
                          value={values.fullName}
                        />
                        <Form.Control.Feedback type='invalid'>
                          {errors.fullName}
                        </Form.Control.Feedback>
                        <Form.Label>{t("BRANCH.FULLNAME")}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6} lg={2} className='mb-4'>
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='nickName'
                          id='nickName'
                          type='text'
                          placeholder={t("BRANCH.NICKNAME")}
                          onChange={handleChange}
                          disabled={isLoading}
                          isInvalid={touched.nickName && !!errors.nickName}
                          value={values.nickName}
                          maxLength={6}
                        />
                        <Form.Control.Feedback type='invalid'>
                          {errors.nickName}
                        </Form.Control.Feedback>
                        <Form.Label>{t("BRANCH.NICKNAME")}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={6} lg={2} className='mb-4'>
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='branchCodeRef'
                          id='branchCodeRef'
                          type='number'
                          min='1'
                          step='1'
                          pattern='\d*'
                          placeholder={t("BRANCH.BRANCH_CODE_REF")}
                          onChange={(event) => {
                            let value = event.target.value ? parseInt(event.target.value, 10) : 0;
                            setFieldValue("branchCodeRef", isNaN(value) ? 0 : value);
                          }}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={
                            touched.branchCodeRef && !!errors.branchCodeRef
                          }
                          value={values.branchCodeRef || 0}
                        />
                        <Form.Control.Feedback type='invalid'>
                          {errors.branchCodeRef}
                        </Form.Control.Feedback>
                        <Form.Label>{t("BRANCH.BRANCH_CODE_REF")}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6} lg={2} className='mb-4'>
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='regionalCodeRef'
                          id='regionalCodeRef'
                          type='number'
                          min='1'
                          step='1'
                          pattern='\d*'
                          placeholder={t("BRANCH.REGIONAL_CODE_REF")}
                          onChange={(event) => {
                            const value = event.target.value ? parseInt(event.target.value, 10) : 0;
                            setFieldValue("regionalCodeRef", value);
                          }}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={
                            touched.regionalCodeRef && !!errors.regionalCodeRef
                          }
                          value={values.regionalCodeRef || 0}
                        />
                        <Form.Control.Feedback type='invalid'>
                          {errors.regionalCodeRef}
                        </Form.Control.Feedback>
                        <Form.Label>{t("BRANCH.REGIONAL_CODE_REF")}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6} lg={2} className='mb-4'>
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                            id='addressStateId'
                            name='addressStateId'
                            isInvalid={touched.addressStateId && !!errors.addressStateId}
                            disabled={isLoading}
                            onChange={handleChange}
                            value={values.addressStateId}                            
                            aria-label={t("BRANCH.STATE")}>
                            <option value="">{t("BRANCH.STATE")}</option>
                            {_.map(states, (l: AddressStateModel) => {
                              return <option key={l.id_address_state} value={l.id_address_state}>{l.name}</option>
                            })}
  
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.addressStateId}
                          </Form.Control.Feedback>
                          <label htmlFor="addressStateId">{t("BRANCH.STATE")}</label>
                        </Form.Floating>
                      </Form.Group>
                  </Col>

                </Row>
                <Row>
                  <Col sm={12} md={6} lg={2} className='mb-4'>
                    <Form.Group>
                      <Form.Floating>
                        <Form.Control
                          name='document'
                          id='document'
                          type='text'
                          placeholder={t("BRANCH.DOCUMENT")}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled={isLoading}
                          isInvalid={touched.document && !!errors.document}
                          value={values.document}
                        />
                        <Form.Control.Feedback type='invalid'>
                          {errors.document}
                        </Form.Control.Feedback>
                        <Form.Label>{t("BRANCH.DOCUMENT")}</Form.Label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>

                  <Col sm={12} md={3} lg={2} className='mb-4'>
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                          id='transporterId'
                          name='transporterId'
                          isInvalid={
                            touched.transporterId && !!errors.transporterId
                          }
                          disabled={isLoading}
                          onChange={handleChange}
                          value={values.transporterId}
                          aria-label={t("BRANCH.TRANSPORTERNAME")}>
                          <option value=''>
                            {t("BRANCH.TRANSPORTERNAME")}
                          </option>
                          {_.map(transporters, (l: TransporterModel) => {
                            return (
                              <option key={l.id} value={l.id}>
                                {l.fullName}
                              </option>
                            );
                          })}
                        </Form.Select>
                        <Form.Control.Feedback type='invalid'>
                          {errors.transporterId}
                        </Form.Control.Feedback>
                        <label htmlFor='transporterId'>
                          {t("BRANCH.TRANSPORTERNAME")}
                        </label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>


                  <Col sm={2} md={6} lg={1}>
                      <Form.Group>
                          <Form.Floating>
                            <Form.Select
                              id='branchEquipBelowMinForApproval'
                              name='branchEquipBelowMinForApproval'
                              isInvalid={
                                touched.branchEquipBelowMinForApproval && !!errors.branchEquipBelowMinForApproval
                              }  
                              disabled={isLoading}
                              onChange={(e) => {
                                const val = e.target.value;
                                setFieldValue("branchEquipBelowMinForApproval", val === "1"); 
                              }}
                              value={
                              values.branchEquipBelowMinForApproval
                                ? "1"
                                : "0"
                              } 
                              aria-label={t("BRANCH.TRANSPORTERNAME")}>  
                              {ListYesNo.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            {errors.branchEquipBelowMinForApproval}
                          </Form.Control.Feedback>
                          <label htmlFor="branchEquipBelowMinForApproval" style={{ fontSize: "11px" }}>{t("BRANCH.ENABLE_APPROVER")}</label>
                          </Form.Floating>
                      </Form.Group>
                  </Col>

                  {/* Emails  */}

                  <Col sm={12} md={6} lg={6}>
                    <Form.Group>
                      <Form.Floating>
                        <EmailChip class="form-control" emails={emails} setState={setEmails} />
                        <label>
                          {t("BRANCH.BRANCH_EMAIL")}
                        </label>
                      </Form.Floating>
                    </Form.Group>
                    {/* <Form.Group>
                      <Form.Floating>
                        <EmailChip class="form-control" emails={emails_branch_manager} setState={setEmails_branch_manager} />
                        <label>
                          {t("BRANCH.MANAGER_EMAIL")}
                        </label>
                      </Form.Floating>
                    </Form.Group> */}
                  </Col>

                  {/* <div className='input-group'>
                    <InputTags
                      style={{color:'black !important'}}
                      values={emails}
                      onTags={(value) => setEmails(value.values) }
                    />
                    <button
                      className="btn btn-warning"
                      type="button"
                      data-testid="button-clearAll"
                      onClick={() => {
                        setEmails([]);
                      }}
                    >
                      Limpar
                    </button>
                  </div> */}
                </Row>

                {/* <label>{t('BRANCH_MONITORING.TIME_SCHEDULING')}:</label>
                <br />
                <br /> */}

                {/* <FieldArray
                  name="branchMonitoringList"
                  render={arrayHelpers => (
                    <Row>
                      <Col sm={12} md={3} lg={2} className="mb-4">
                    <Form.Group>
                      <Form.Floating>
                        <Form.Select
                          id='monitoringSystemId'
                          name='monitoringSystemId'
                          isInvalid={touched.monitoringSystemId && !!errors.monitoringSystemId}
                          disabled={isLoading}
                          onChange={handleChange}
                          value={values.monitoringSystemId}
                          aria-label={t("BRANCH.MONITORING_SYSTEM")}>
                          <option value="">{t("BRANCH.MONITORING_SYSTEM")}</option>
                          {_.map(monitoringSystemList, (l: MonitoringSystemModel) => {
                            return <option key={l.id} value={l.id}>{l.monitoringSystemDescription}</option>
                          })}

                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors.transporterId}
                        </Form.Control.Feedback>
                        <label htmlFor="transporterId">{t("BRANCH.TRANSPORTERNAME")}</label>
                      </Form.Floating>
                    </Form.Group>
                  </Col>
                      <Col sm={12} md={3} lg={2} className="mb-4">
                        <Form.Group>
                        <DatePicker
                            onChange={(e) => {setValues({ ...values, startTime: e });}}                            
                            className={'form-control'}
                            placeholderText={t('BRANCH_MONITORING.START_TIME')}
                            showTimeSelect                            
                            showTimeSelectOnly
                            selected={values.startTime}
                            dateFormat={"HH:mm"}
                          />                        
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={3} lg={2} className="mb-4">
                        <Form.Group>
                        <DatePicker
                            onChange={(e) => {setValues({ ...values, finishTime: e });}}                            
                            className={'form-control'}
                            placeholderText={t('BRANCH_MONITORING.FINISH_TIME')}
                            showTimeSelect                            
                            showTimeSelectOnly
                            selected={values.finishTime}
                            dateFormat={"HH:mm"}
                          />
                        </Form.Group>
                      </Col>
                      <Col sm={12} md={3} lg={2} className="mb-4">
                        <Form.Group>
                          <Form.Control
                            name='intervalTime'
                            id='intervalTime'
                            type='number'
                            min='1'
                            placeholder={t('BRANCH_MONITORING.INTERVAL_TIME')}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            disabled={isLoading}
                            isInvalid={touched.intervalTime && !!errors.intervalTime}
                            value={values.intervalTime}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.intervalTime}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col sm={12} md={2} lg={1} className="mt-auto mb-4">
                        <Button disabled={isLoading } onClick={() => {
                          if (!values.startTime || !values.finishTime || !values.intervalTime || !values.monitoringSystemId)  
                          {
                            ToastService.error(t('BRANCH.EMPTY_BRANCH_MONITORING_VALIDATION'))
                          } else 
                          {
                            if (moment(values.startTime).format("HH:mm") < moment(values.finishTime).format("HH:mm"))
                            {
                              arrayHelpers.push(_.clone({ monitoringSystemId: values.monitoringSystemId, startTime: moment(values.startTime).format("HH:mm"), finishTime: moment(values.finishTime).format("HH:mm"), intervalTime: values.intervalTime}));
                              setFieldValue('startTime', '');
                              setFieldValue('finishTime', '');
                              setFieldValue('intervalTime', '');
                              setFieldValue('monitoringSystemId', '');
                            }
                            else
                            {
                              ToastService.error(t('BRANCH_MONITORING.INVALID_TIME_SCHEDULING'));
                            }
                          }
                        }}>
                          <span>{t('BUTTON_ADD')}</span>
                        </Button>
                      </Col>

                      <label>{t('BRANCH_MONITORING.MONITORING')}:</label>
                      <br />
                      <br />
                      <Row className='mb-3'>
                        <Col lg={6} md={10} sm={12}>
                          <Table striped bordered hover>
                            <thead>
                              <tr>
                                <th>{t('BRANCH_MONITORING.SCHEDULED_TIMES')}</th>
                                <th></th>
                              </tr>
                            </thead>
                            <tbody>
                              {values.branchMonitoringList && values.branchMonitoringList.length > 0 && (
                                values.branchMonitoringList.map((branchMonitoring, index) => (
                                  <tr key={index}>
                                    <td>
                                      <label>{monitoringSystemList?.filter(v => v.id === values.branchMonitoringList[index].monitoringSystemId)[0]?.monitoringSystemDescription}: {`${t('EVENT.AT')} ${values.branchMonitoringList[index].startTime} ${t('EVENT.TO')} ${values.branchMonitoringList[index].finishTime}`}
                                        &nbsp;({t('BRANCH_MONITORING.INTERVAL_TIME')}:&nbsp;
                                        {values.branchMonitoringList[index].intervalTime})
                                      </label>
                                    </td>
                                    <td>
                                      <Button disabled={isLoading} onClick={() => { arrayHelpers.remove(index) }}>
                                        <span>{t('DELETE')}</span>
                                      </Button>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </Table>
                        </Col>
                      </Row>

                    </Row>
                  )}
                /> */}
                <Row>
                  <Col sm={12} md={6} lg={5} className="mb-4">
                    <Table striped bordered hover>
                      <thead>
                        <tr>
                          <th>{t("BRANCH.DAYS_WORKS")}</th>
                          <th>{t("BRANCH.EXTRA_HOUR")}</th>
                          <th>{t("BRANCH.EXCEED")}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='checkbox'
                                id={`worksOnMonday`}
                                name={`worksOnMonday`}
                                label={t("MONDAY")}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    exceedOnMonday:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : prevValues.exceedOnMonday,
                                    extraHourOnMonday:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : prevValues.extraHourOnMonday,
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.worksOnMonday === "1"}
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='switch'
                                id={`extraHourOnMonday`}
                                name={`extraHourOnMonday`}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    worksOnMonday: "1",
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.extraHourOnMonday === "1"}
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='switch'
                                id={`exceedOnMonday`}
                                name={`exceedOnMonday`}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    worksOnMonday: "1",
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.exceedOnMonday === "1"}
                              />
                            </Form.Group>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='checkbox'
                                id={`worksOnTuesday`}
                                name={`worksOnTuesday`}
                                label={t("TUESDAY")}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    exceedOnTuesday:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : prevValues.exceedOnTuesday,
                                    extraHourOnTuesday:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : prevValues.extraHourOnTuesday,
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.worksOnTuesday === "1"}
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='switch'
                                id={`extraHourOnTuesday`}
                                name={`extraHourOnTuesday`}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    worksOnTuesday: "1",
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.extraHourOnTuesday === "1"}
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='switch'
                                id={`exceedOnTuesday`}
                                name={`exceedOnTuesday`}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    worksOnTuesday: "1",
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.exceedOnTuesday === "1"}
                              />
                            </Form.Group>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='checkbox'
                                id={`worksOnWednesday`}
                                name={`worksOnWednesday`}
                                label={t("WEDNESDAY")}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    exceedOnWednesday:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : prevValues.exceedOnWednesday,
                                    extraHourOnWednesday:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : prevValues.extraHourOnWednesday,
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.worksOnWednesday === "1"}
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='switch'
                                id={`extraHourOnWednesday`}
                                name={`extraHourOnWednesday`}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    worksOnWednesday: "1",
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.extraHourOnWednesday === "1"}
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='switch'
                                id={`exceedOnWednesday`}
                                name={`exceedOnWednesday`}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    worksOnWednesday: "1",
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.exceedOnWednesday === "1"}
                              />
                            </Form.Group>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='checkbox'
                                id={`worksOnThursday`}
                                name={`worksOnThursday`}
                                label={t("THURSDAY")}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    exceedOnThursday:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : prevValues.exceedOnThursday,
                                    extraHourOnThursday:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : prevValues.extraHourOnThursday,
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.worksOnThursday === "1"}
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='switch'
                                id={`extraHourOnThursday`}
                                name={`extraHourOnThursday`}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    worksOnThursday: "1",
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.extraHourOnThursday === "1"}
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='switch'
                                id={`exceedOnThursday`}
                                name={`exceedOnThursday`}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    worksOnThursday: "1",
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.exceedOnThursday === "1"}
                              />
                            </Form.Group>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='checkbox'
                                id={`worksOnFriday`}
                                name={`worksOnFriday`}
                                label={t("FRIDAY")}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    exceedOnFriday:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : prevValues.exceedOnFriday,
                                    extraHourOnFriday:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : prevValues.extraHourOnFriday,
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.worksOnFriday === "1"}
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='switch'
                                id={`extraHourOnFriday`}
                                name={`extraHourOnFriday`}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    worksOnFriday: "1",
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.extraHourOnFriday === "1"}
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='switch'
                                id={`exceedOnFriday`}
                                name={`exceedOnFriday`}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    worksOnFriday: "1",
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.exceedOnFriday === "1"}
                              />
                            </Form.Group>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='checkbox'
                                id={`worksOnSaturday`}
                                name={`worksOnSaturday`}
                                label={t("SATURDAY")}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    exceedOnSaturday:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : prevValues.exceedOnSaturday,
                                    extraHourOnSaturday:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : prevValues.extraHourOnSaturday,
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.worksOnSaturday === "1"}
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='switch'
                                id={`extraHourOnSaturday`}
                                name={`extraHourOnSaturday`}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    worksOnSaturday: "1",
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.extraHourOnSaturday === "1"}
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='switch'
                                id={`exceedOnSaturday`}
                                name={`exceedOnSaturday`}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    worksOnSaturday: "1",
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.exceedOnSaturday === "1"}
                              />
                            </Form.Group>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='checkbox'
                                id={`worksOnSunday`}
                                name={`worksOnSunday`}
                                label={t("SUNDAY")}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    exceedOnSunday:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : prevValues.exceedOnSunday,
                                    extraHourOnSunday:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : prevValues.extraHourOnSunday,
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.worksOnSunday === "1"}
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='switch'
                                id={`extraHourOnSunday`}
                                name={`extraHourOnSunday`}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    worksOnSunday: "1",
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.extraHourOnSunday === "1"}
                              />
                            </Form.Group>
                          </td>
                          <td>
                            <Form.Group>
                              <Form.Check
                                type='switch'
                                id={`exceedOnSunday`}
                                name={`exceedOnSunday`}
                                onChange={(event) => {
                                  setValues((prevValues) => ({
                                    ...prevValues,
                                    worksOnSunday: "1",
                                    [event.target.name]:
                                      prevValues[event.target.name] === "1"
                                        ? "0"
                                        : "1",
                                  }));
                                }}
                                checked={values.exceedOnSunday === "1"}
                              />
                            </Form.Group>
                          </td>

                        </tr>
                      </tbody>
                    </Table>
                  </Col>
                  <Col sm={5} md={5} lg={6}> {/* Ajuste o tamanho e margem conforme necessário */}
                    <div>
                      <h1  style={{ color: '#007bff' }}>{t("TITLE_APPROVED_BRANCHS")}</h1>
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th style={{ width: '50%' }}>{t("BRANCH.FULLNAME")}</th>
                            <th style={{ width: '50%' }}>{t("BRANCH.EMAIL")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {groupBranchData?.length > 0 ? (
                            groupBranchData.map((item, index) => (
                              <tr key={index}>
                                <td>{item.fullName}</td>
                                <td>{item.email}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td>{t("NO_APPROVER_AVAILABLE")}</td>
                              <td> </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </Col>
                </Row>

              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </>
  );
};
